import { createFileRoute } from '@tanstack/react-router';
import { EventDetailPage } from '@pages/event-detail';

/** Route für die Ticket-Detailseite (/tickets/:eventId). */
export const Route = createFileRoute('/tickets/$eventId')({
  component: function TicketDetailRoute() {
    const { eventId } = Route.useParams();
    return <EventDetailPage eventId={eventId} />;
  },
});
